import {
  Spinner,
  Table as ChakraTable,
  TableContainer,
  Center
} from "@chakra-ui/react"

import { ITableProps } from "./TableTypes"
import TableHeader from "./TableHeader"
import TableContent from "./TableContent"
import Pagination from "./Pagination"
import TableEmptyState from "./TableEmptyState"

const Table: React.FC<ITableProps> = ({
  data,
  columns,
  loading,
  nestedColumns = [],
  actions = [],
  insideActions = [],
  displayHeader = true,
  pagination,
  topBorderRadius = true,
  collapseButton = false,
  extraHeaderCols = 0,
  tableValue,
  handleTableSize,
  userRole,
  overflow = "hidden",
  isReportsPage = false,
  T
}) => {
  return (
    <TableContainer background={"white"} borderRadius={"base"} borderTopRadius={!topBorderRadius ? "unset" : "base"} overflowY={overflow}>
      <ChakraTable variant='simple'>
        {displayHeader && <TableHeader isReportsPage={isReportsPage} columns={columns} extraCols={extraHeaderCols} />}
        <TableContent isReportsPage={isReportsPage} data={data} columns={columns} insideActions={insideActions} actions={actions} nestedColumns={nestedColumns} collapseButton={collapseButton} userRole={userRole} />
      </ChakraTable>
      {loading && <Center w="100%"><Spinner /></Center>}
      {!loading && pagination && data.length < pagination?.total && <Pagination {...pagination} value={tableValue}
        handleTableSize={handleTableSize} />}
      {!loading && data.length === 0 && <TableEmptyState T={T} isReportsPage={isReportsPage} />}
    </TableContainer>
  )
}

export default Table
